import { appendStyle } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { NotificationAnimationMapBaseController } from '../notifications-base-container';
export class NotificationAnimationMapController extends NotificationAnimationMapBaseController {
    constructor(element) {
        super(element);
        this.topOffset = 100;
    }
    async onBeforeRemoveAnimateItem(element) {
        if (element.id === this.onKeyExtractor(['fullView', null])) {
            element.animate([{ opacity: 1 }, { opacity: 0 }], { ...this.animationOptions, duration: 150 });
            return;
        }
        await element.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(110%)' }], this.animationOptions).finished;
    }
    async onBeforeRenderAnimateItem(element) {
        appendStyle(element, {
            transform: 'translateX(110%)',
        });
    }
    async onAfterMoveAnimationItem(element, newIndex) {
        const rect = element.getBoundingClientRect();
        if (rect.top > window.innerHeight + this.topOffset) {
            return;
        }
        const offset = this.getOffsetByIndex(newIndex);
        await element.animate([{ transform: `translateY(${offset * -1}px)` }, { transform: `translateY(0)` }], this.animationOptions).finished;
    }
    async onAfterRenderAnimateItemTransition(element, index) {
        const offset = 100 + index * 50;
        await element.animate([{ transform: `translateX(${offset}%)` }, { transform: 'translateX(0)' }], {
            ...this.animationOptions,
            duration: this.animationOptions.duration + index * 50,
        }).finished;
    }
    onAfterRenderAnimateItemSkipTransition(element) {
        appendStyle(element, {
            transform: '',
        });
    }
}
//# sourceMappingURL=notification-animation-map-controller.js.map